module.exports = __webpack_public_path__ + "img/st1.png";